"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.walletWithdrawalSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const WalletWithdrawInterface_1 = require("../WalletWithdrawInterface");
const initialSwapState = Object.assign({}, WalletWithdrawInterface_1.defaultWithdrawState);
exports.walletWithdrawalSlice = (0, toolkit_1.createSlice)({
    name: "walletWithdrawal",
    initialState: initialSwapState,
    reducers: {
        startWithdraw: (state, action) => {
            state.showWithdrawModal = true;
            state.isWithdrawing = true;
            state.receiveTransactionId = action.payload.receiveTransactionId;
        },
        transactionIdReceivedWithdrawal: (state, action) => {
            state.transactionId = action.payload.transactionId;
        },
        withdrawTransactionFound: (state) => {
            state.isWithdrawing = false;
            state.isWithdrawn = true;
            // state.showWithdrawModal = false;
        },
        closeWithdrawModal: (state) => {
            state.showWithdrawModal = false;
        },
        withdrawTransactionfail: (state) => {
            state.isWithdrawing = false;
            state.isWithdrawn = false;
        },
        resetWithdraw: (state) => {
            state.showWithdrawModal = false;
            state.isWithdrawing = false;
            state.isWithdrawn = false;
            state.transactionId = "";
            state.receiveTransactionId = "";
            state.withdrawnTransactionId = "";
            state.status = "";
        },
    },
});
//# sourceMappingURL=WalletWithdrawalSlice.js.map